import { Monitor, Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@/hooks/useTheme';
import type { ThemeMode } from '@/context/ThemeContext';

const MODES: { key: ThemeMode; icon: typeof Sun; tKey: string }[] = [
  { key: 'auto', icon: Monitor, tKey: 'theme.auto' },
  { key: 'light', icon: Sun, tKey: 'theme.light' },
  { key: 'dark', icon: Moon, tKey: 'theme.dark' },
];

export function ThemeToggle() {
  const { mode, setMode } = useTheme();
  const { t } = useTranslation();

  return (
    <div
      className="aiobi-theme-toggle"
      role="group"
      aria-label={t('theme.label')}
    >
      {MODES.map(({ key, icon: Icon, tKey }) => (
        <button
          key={key}
          type="button"
          aria-pressed={mode === key}
          aria-label={t(tKey)}
          title={t(tKey)}
          onClick={() => setMode(key)}
        >
          <Icon size={14} />
          <span>{t(tKey)}</span>
        </button>
      ))}
    </div>
  );
}
